<template>
  <div>
    <!-- 顶部导航栏 -->
    <div class="page-header">
      <div class="logo">慧教云创</div>
      <nav class="nav-menu">
        <span
          class="nav-item"
          :class="{active: $route.path === '/'}"
          @click="$router.push('/home')"
        >首页</span>
        <span
          class="nav-item"
          :class="{active: $route.path === '/productCenter'}"
          @click="$router.push('/productCenter')"
        >产品中心</span>
        <span
          class="nav-item"
          :class="{active: $route.path === '/contact'}"
          @click="$router.push('/contact')"
        >联系我们</span>
      </nav>
    </div>
  </div>
</template>

<script>
  export default {
    name: "myHeader"
  }
</script>

<style scoped lang="scss">
  .page-header {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 120px;
    background: url("~@/../static/assets/header_bgc.png") no-repeat left top / contain;
  }

  .logo {
    font-size: 30px;
    font-weight: bold;
    color: #214073;
  }

  .nav-menu {
    display: flex;
    gap: 48px;
  }

  .nav-item {
    font-size: 17px;
    color: #333;
    cursor: pointer;
    padding: 6px 0;
  }

  .nav-item.active {
    color: #214073;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/myHeader.vue